<div class="pipeline-topbar">
  <!-- Back breadcrumb -->
  <div class="topbar-left">
    <button class="back-btn" (click)="handleBackClick()">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <div class="breadcrumb">
      <span class="breadcrumb-parent">Workflows</span>
      <span class="breadcrumb-sep">/</span>
      <span class="breadcrumb-current">{{ workflowName }}</span>
    </div>
    <div class="version-badge">{{ version }}</div>
    <div class="status-badge" [class.published]="status === 'PUBLISHED'">
      {{ status }}
    </div>
  </div>

  <!-- Save status -->
  <div class="topbar-center">
    <span class="save-status" [class.saving]="saveStatus === 'saving'" [class.saved]="saveStatus === 'saved'">
      <ng-container *ngIf="saveStatus === 'saving'">Saving…</ng-container>
      <ng-container *ngIf="saveStatus === 'saved'">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2 6l3 3 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Saved
      </ng-container>
    </span>
  </div>

  <!-- Actions -->
  <div class="topbar-right">
    <button class="btn-validate" (click)="handleValidateClick()">Validate</button>
    <button
      class="btn-publish"
      [class.saving]="saveStatus === 'saving'"
      (click)="handlePublishClick()">
      <ng-container *ngIf="saveStatus !== 'saving'">Publish</ng-container>
      <ng-container *ngIf="saveStatus === 'saving'">
        <span class="spinner"></span>
        Publishing…
      </ng-container>
    </button>
  </div>
</div>
